module.exports = __webpack_public_path__ + "static/media/IMG_6.3b5c7247.jpg";